import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

const appRedirectUri = `${window.location.origin}${window.location.pathname}`

export const userManager = new UserManager({
  authority: import.meta.env.VITE_AUTHORITY,

  client_id: import.meta.env.VITE_CLIENT_ID,

  redirect_uri: appRedirectUri,

  // Used by e-sign forced re-auth (signinPopup). Defaults to redirect_uri; set
  // explicitly so popup flow does not depend on that fallback behavior.
  // The e-sign call also passes popupWindowTarget ('gcis-esign-reauth') so the
  // parent can refocus the same named window without opening another popup.
  popup_redirect_uri: appRedirectUri,

  post_logout_redirect_uri: window.location.origin,

  userStore: new WebStorageStateStore({ store: window.sessionStorage }),

  monitorSession: true,
})

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname)
}
